import React, { useState, useEffect } from 'react';
import { Lock, Crown, Sparkles, X } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const tb = { fontFamily: "'Tiro Bangla', serif" };
const toBnNum = (n) => String(n).replace(/[0-9]/g, d => '০১২৩৪৫৬৭৮৯'[d]);

export default function LockedFeatureModal({ open, isOpen, onClose, title, featureName, icon: Icon, gradientClass }) {
    const [price, setPrice] = useState(135);
    const visible = open || isOpen;

    useEffect(() => {
        if (visible) {
            axios.get(`${API}/pricing-config`).then(r => {
                const p = r.data.premium_weekly_price || r.data?.config?.premium_weekly_price;
                if (p) setPrice(p);
            }).catch(() => {});
        }
    }, [visible]);

    if (!visible) return null;

    const displayTitle = featureName || title || 'Premium Content';

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
            <div className="w-full max-w-sm bg-white rounded-3xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-testid="locked-feature-modal">
                <div className={`h-1.5 w-full bg-gradient-to-r ${gradientClass || 'from-purple-600 to-pink-600'}`} />
                <div className="p-6 relative">
                    <button onClick={onClose} className="absolute top-4 right-4 w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors" data-testid="locked-modal-close">
                        <X className="w-3.5 h-3.5 text-gray-500" />
                    </button>

                    <div className="flex justify-center mb-4">
                        <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${gradientClass || 'from-purple-100 to-pink-100'} flex items-center justify-center shadow-lg`}>
                            {Icon ? <Icon className="w-8 h-8 text-white" /> : <Lock className="w-8 h-8 text-white" />}
                        </div>
                    </div>

                    <h3 className="text-center text-lg font-bold text-slate-800 mb-1" style={tb}>
                        {displayTitle} Lock আছে
                    </h3>
                    <p className="text-center text-xs text-slate-400 mb-4" style={tb}>এই feature-টি Premium সদস্যদের জন্য</p>

                    <div className="p-3 rounded-xl bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-100 mb-4">
                        <div className="flex items-center justify-center gap-1.5">
                            <Crown className="w-4 h-4 text-purple-600" />
                            <span className="font-bold text-purple-700" style={tb}>Premium — মাত্র {toBnNum(price)} টাকা/সপ্তাহ</span>
                        </div>
                    </div>

                    <a
                        href="mailto:info@bakkoshilpi.com?subject=Premium Unlock&body=আমি Premium unlock করতে চাই।"
                        className="w-full py-3 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-sm text-center hover:opacity-90 transition-all shadow-lg block mb-3"
                        data-testid="locked-modal-unlock-btn"
                        style={tb}
                    >
                        <Sparkles className="w-4 h-4 inline mr-1.5" />এখনই Unlock করো
                    </a>

                    <p className="text-center text-[10px] text-slate-400" style={tb}>
                        যোগাযোগ: <a href="mailto:info@bakkoshilpi.com" className="underline font-semibold text-amber-600">info@bakkoshilpi.com</a>
                    </p>
                </div>
            </div>
        </div>
    );
}
